import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const KundensortimentDtoServiceConfig = {
  name: "KundensortimentDto",
  annotations: []
} as ServiceConfig;